/*
 * Copyright (c) 2015 - 2023 by KAA Soft. All rights reserved.
 */

export function codeEditor(element) {
  var editor = ace.edit(element);
  /**
   * @param dataset.textareaId
   */
  var textareaId = element.dataset.textareaId;
  if (!textareaId) return console.warn('Textarea Id is not specified.');
  var textarea = document.getElementById(textareaId);
  editor.setOptions({
    tabSize: 4,
    minLines: 20,
    maxLines: 50,
    showPrintMargin: false,
    fontSize: '.85rem',
    theme: 'ace/theme/nord_dark',
    mode: 'ace/mode/smarty'
  });
  editor.getSession().setValue(textarea.value);
  editor.getSession().on('change', function () {
    textarea.value = editor.getSession().getValue();
  });
}
export function codeEditorInit(containerSelector) {
  if (containerSelector === void 0) {
    containerSelector = 'body';
  }
  var container = document.querySelector(containerSelector);
  if (typeof ace != "undefined") {
    var codeEditorElements = container.querySelectorAll(".code-editor");
    for (var i = 0; i < codeEditorElements.length; i++) {
      codeEditor(codeEditorElements[i]);
    }
  }
}